import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import { Menu, MenuItem, MenuItemLabel } from "@/components/ui/menu";
import { Image } from "@/components/ui/image";
import { Box } from "@/components/ui/box";
import { Divider } from "@/components/ui/divider";
import { Popover, PopoverBackdrop, PopoverContent, PopoverArrow, PopoverBody, PopoverCloseButton } from "@/components/ui/popover";
import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import i18n from "@/assets/i18n";
import { placeholderImg } from '@/assets/images';
import * as MediaSelector from "@/components/media/MediaSelector";
import { IconM, IconMC } from '@/components/media/IconsV2';
import { ResizeMode, Video } from 'expo-av';
import { switchScreen } from '@/hooks/navigate';
import MediaDraw from '@/components/media/MediaDraw';
import ModalSendCopy from '../modals/ModalSendCopy';
import ModalReport from '../modals/ModalReport';
import ImageSynced from '@/components/media/ImageSynced';
import BasicButton from '@/components/basic/BasicButton';
import avatar1 from "@/assets/images/avatar_mit_background.png"
import inaLogo from "@/assets/icons/icon_blue_rounded_512x512.png"
import Moment from 'moment';

const categories = ['taskSettings.any', 'taskSettings.home', 'taskSettings.garden', 'taskSettings.allday', 'taskSettings.medic', 'taskSettings.diy', 'taskSettings.cook', 'taskSettings.other']

const MediaBox = (props) => {
    const [isVideo, setIsVideo] = useState(props.isVideo)

    const onErrorVideo = (error) => {
        console.log('ERROR', error)
        setIsVideo(false)
    }

    return (
        <View>
            {isVideo ?
                <Video key={props.media} source={props.media} style={{ justifyContent: 'center', width: props.size, height: props.size }} useNativeControls={false} resizeMode={ResizeMode.COVER} onError={onErrorVideo} onReadyForDisplay={videoData => {
                    videoData.srcElement.style.position = 'unset'
                }} isLooping={true} shouldPlay={true} isMuted={true} />
                :
                <Image key={props.media} source={props.media} fallbackSource={placeholderImg} resizeMode='cover' alt={i18n.t('aria.image.card')} className={props.className} />
            }
            <MediaDraw size={props.size} overlay={props.overlay} />
        </View>
    );
}

const MarketPopover = (props) => {
    const user = useSelector((state) => state.user)
    const [avatar, setAvatar] = useState(props.item.profileimage || avatar1)

    const [isOpen, setIsOpen] = useState(false)

    const openPopover = () => {
        setIsOpen(true)
    }

    const showPreview = (workflow) => {
        console.log('MARKET', workflow.workflowid)
        // switchScreen(navigation, 'AppView', { screen: 'MainStack', params: { screen: 'ShowWorkflow', params: { taskid: 'FE674948-defb-400e-a79a-a21557666230' } } })
    }

    return (
        <Popover trigger={(triggerProps) => {
            return (
                <Pressable {...triggerProps} onPress={() => openPopover()} className="m-2">
                    {props.children}
                </Pressable>
            );
        }} isOpen={isOpen} onClose={() => setIsOpen(false)} placement='right' size='full'>
            <PopoverBackdrop />
            <PopoverContent className="bg-secondary-50 p-2">
                <PopoverArrow />
                <PopoverBody alignItems='center'>
                    <VStack className={` w-[340px] flex-1 bg-secondary-50 justify-end `}>
                        <PopoverCloseButton className="absolute top-1 right-1" onPress={() => setIsOpen(false)}>
                            <View className='bg-primary-50 border-2 border-primary-900 rounded-[4px] p-1 w-fit self-end'>
                                <IconMC className='text-primary-900' size={24} name='close' />
                            </View>
                        </PopoverCloseButton>
                        <Pressable onPress={() => { showPreview(props.item) }} className="m-2" >
                            <MediaBox key={props.media} media={props.media} overlay={props.overlay} isVideo={props.isVideo} size={340} className='w-[340px] h-[340px]' />
                            <Text isTruncated={true} className="max-w-full text-md mt-4 text-secondary-900">
                                <Text bold className="text-xl text-primary-900">{props.changed ? i18n.t('global.new') : ''}</Text>
                                <Text isTruncated={true} className="max-w-full text-lg font-semibold text-secondary-900">{props.item.data.title || i18n.t('studio.main.noTitle')}</Text>
                            </Text>
                            <Text className="text-sx text-secondary-900">{(props.item.profilename || '') + (user.isAdmin ? ' - ' + props.item.ownermail : '')}</Text>
                            <Text className="text-md my-4 text-secondary-900">{props.item.takenat ? i18n.t('studio.market.giftTakenAt', { date: Moment(props.item.takenat).format('DD.MM.YYYY') }) : ''}</Text>
                            <VStack space='xs' className="bg-secondary-50 opacity-90 items-center">
                                <HStack space='xl' className="w-[100%]">
                                    <BasicButton onPress={() => { props.takeItem(props.item?.id, props.item.data.title || i18n.t('studio.main.noTitle')); setIsOpen(false) }} text={i18n.t('studio.market.giftTake')} width='50%' />
                                    <IconMC className='absolute right-4 top-2 text-primary-900' size={24} name={props.item.isliked ? 'cards-heart' : 'cards-heart-outline'} />
                                    <Pressable onPress={() => { props.likeItem(props.item?.id) }} className="absolute right-1 w-8 h-8" />
                                </HStack>
                                <Divider className="mt-4 self-center" />
                                <HStack space='md' className="w-[100%]">
                                    <IconMC className='pt-1 text-primary-900' size={16} name='cards-heart-outline' />
                                    <Text className="text-sx text-secondary-900">{props.item.likecount}</Text>
                                    <Text className="text-sx text-secondary-400">|</Text>
                                    <IconM className='pt-1 text-primary-900' size={16} name='people-outline' />
                                    <Text className="text-sx text-secondary-900">{props.item.takecount}</Text>
                                    <Text className="text-sx text-secondary-400">|</Text>
                                    <Text className="text-sx text-secondary-900">{Moment(props.item.createdat).format('DD.MM.YYYY')}</Text>
                                    <Text className="text-sx text-secondary-400">|</Text>
                                    <Text className="text-sx text-secondary-900">{i18n.t(categories[+props.item.stats.category || 7])}</Text>
                                </HStack>
                            </VStack>
                            <Text className="text-md mt-4 text-secondary-900">{props.item.data.description || i18n.t('studio.main.noText')}</Text>
                            {avatar &&
                                <Box className={` top-[308px] absolute right-1 border border-primary-900 rounded-full `}>
                                    <ImageSynced key={avatar} uri={avatar} isAvatar={true} className='bg-secondary-50' size='md' />
                                </Box>}
                        </Pressable>
                    </VStack >
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}

const CardFrame = (props) => {
    return (props.market ? <MarketPopover {...props}>
        {props.children}
    </MarketPopover> : <Pressable onPress={() => { switchScreen(props.navigation, 'editor', { workflow: props.item }) }} className="m-2" >
        {props.children}
    </Pressable>);
}

export default function WorkflowCard({ item, navigation, market, deleteItem, duplicateItem, sendItem, takeItem, likeItem, changed }) {
    const user = useSelector((state) => state.user)
    const [title, setTitle] = useState(i18n.t('studio.main.emptyWorkflow'))
    const [subtitle, setSubtitle] = useState('')
    const [media, setMedia] = useState(placeholderImg)
    const [overlay, setOverlay] = useState([])
    const [isVideo, setIsVideo] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [showReport, setShowReport] = useState(false)
    const [avatar, setAvatar] = useState(user.avatar || user.id || avatar1)

    useEffect(() => {
        if (market) {
            setTitle(item.data.title.substring(0, 20) + (item.data.title.length > 20 ? '...' : ''))
            setSubtitle(i18n.t(categories[+item.stats.category || 7]))
            setAvatar(item.profileimage || avatar1)
            const workflowMediaId = item.data?.media?.[0]
            if (workflowMediaId) {
                setOverlay(item.data?.overlays?.[workflowMediaId] || [])
                setMedia(MediaSelector.imageSrc(workflowMediaId, false))
                setIsVideo(MediaSelector.isMedia(workflowMediaId))
            }
        } else {
            if (item?.flowData) {
                if (item?.title) {
                    setTitle(item.title.substring(0, 20) + (item.title.length > 20 ? '...' : ''))
                } else {
                    setTitle(i18n.t('studio.main.noTitle'))
                }
                const data = item?.flowData?.nodes?.[0]?.data;
                setSubtitle(i18n.t('showWorkflowScreen.numberOfSteps', { steps: item?.flowData?.nodes?.length - 2 || 0 }))
                const workflowMediaId = data?.media?.[0]
                if (workflowMediaId) {
                    setOverlay(data?.overlays?.[workflowMediaId] || [])
                    setMedia(MediaSelector.imageSrc(workflowMediaId, false))
                    setIsVideo(MediaSelector.isMedia(workflowMediaId))
                }
            } else {
                setTitle(item.title.substring(0, 20) + (item.title.length > 20 ? '...' : ''))
                setSubtitle(i18n.t('showWorkflowScreen.numberOfSteps', { steps: item.steps.length }))
                setAvatar(item?.simulatorPreview || item?.id.length < 2 ? inaLogo : item.owned ? avatar : item.contact || avatar1)
                const workflowMediaId = item?.media?.[0]
                if (workflowMediaId) {
                    setOverlay(item?.overlays?.[workflowMediaId] || [])
                    setMedia(MediaSelector.imageSrc(workflowMediaId, false))
                    setIsVideo(MediaSelector.isMedia(workflowMediaId))
                }
            }
        }
    }, [])

    const MoreOptionsMenu = () => {
        return (
            <Menu placement='bottom left' trigger={triggerProps => {
                return (
                    <View className="absolute p-1 top-1 right-1 bg-[#FFFFFFC0] border border-primary-900 rounded-[4px]">
                        <IconM className='text-primary-900' size={24} name='more-vert' />
                        <Pressable {...triggerProps} className="absolute w-8 h-8" />
                    </View>
                );
            }}>
                {!market && <MenuItem onPress={() => { switchScreen(navigation, 'editor', { workflow: item }) }} textValue={item?.flowData ? i18n.t('footer.edit') : i18n.t('studio.main.show')}>
                    <MenuItemLabel className="text-sm">{market ? i18n.t('studio.market.info') : item?.flowData ? i18n.t('footer.edit') : i18n.t('studio.main.show')}</MenuItemLabel>
                </MenuItem>}
                {item?.flowData && duplicateItem &&
                    <MenuItem onPress={() => { duplicateItem(item?.id) }} textValue={i18n.t('workflowsScreen.duplicate')}>
                        <MenuItemLabel className="text-sm">{i18n.t('workflowsScreen.duplicate')}</MenuItemLabel>
                    </MenuItem>}
                {item?.flowData && sendItem &&
                    <MenuItem onPress={() => setShowModal(true)} textValue={i18n.t('workflowsScreen.copy')}>
                        <MenuItemLabel className="text-sm">{i18n.t('workflowsScreen.copy')}</MenuItemLabel>
                    </MenuItem>}
                {deleteItem &&
                    market ? ((item.isowned || user.isAdmin) &&
                        <MenuItem onPress={() => { deleteItem(item.id) }} textValue={i18n.t('studio.market.remove')}>
                            <MenuItemLabel className="text-sm">{i18n.t('studio.market.remove')}</MenuItemLabel>
                        </MenuItem>) :
                    (item?.flowData && <MenuItem onPress={() => { deleteItem(item?.id) }} textValue={i18n.t('workflowsScreen.delete')}>
                        <MenuItemLabel className="text-sm">{i18n.t('workflowsScreen.delete')}</MenuItemLabel>
                    </MenuItem>)}
                <MenuItem onPress={() => setShowReport(true)} textValue={i18n.t('moreOptionsMenu.report')}>
                    <MenuItemLabel className="text-sm text-error-600">{i18n.t('moreOptionsMenu.report')}</MenuItemLabel>
                </MenuItem>
            </Menu>
        );
    }

    const getIcon = () => {
        if (item?.flowData) {
            return 'tv'
        } else if (item?.public) {
            return 'qr-code'
        } else if (!item?.owned) {
            return 'share'
        } else if (item?.id?.length < 2 || !item?.flowData) {
            return 'phone-android'
        } else {
            return ''
        }
    }

    return (
        <CardFrame item={item} media={media} overlay={overlay} isVideo={isVideo} market={market} changed={changed} takeItem={takeItem} likeItem={likeItem} navigation={navigation}>
            <VStack className={` shadow-[2px_2px_8px_0] ${changed ? 'shadow-primary-900/80' : 'shadow-secondary-900/80'} rounded-md border border-[#BEBEBE] bg-secondary-50 justify-end items-center `} >
                <MediaBox key={media} media={media} overlay={overlay} isVideo={isVideo} size={200} className='w-[200px] h-[200px] rounded-md' />
                <VStack space='xs' className="absolute bg-secondary-50 opacity-90 items-center p-2 w-[200px] min-h-[64px] rounded-bl-md rounded-br-md">
                    <Text isTruncated={true} className="max-w-full text-md text-secondary-900">
                        {changed && <Text className="text-lg font-bold text-primary-900">{i18n.t('global.new')}</Text>}
                        <Text isTruncated={true} className="max-w-full text-md font-semibold text-secondary-900">{title}</Text>
                    </Text> 
                    <Text isTruncated={true} className="max-w-full text-sm text-secondary-900">{subtitle}</Text>
                </VStack>
                <MoreOptionsMenu />
                {!market && <View className="absolute p-1 top-1 left-1 bg-[#FFFFFFC0] border border-transparent rounded-[4px]">
                    <IconM className='text-primary-900' size={24} name={getIcon()} />
                </View>}
                {avatar &&
                    <Box className="absolute bottom-12 right-1 border border-primary-900 rounded-full">
                        <ImageSynced key={avatar + user.updated} uri={avatar} refresh={user.updated} isAvatar={true} className='bg-secondary-50' size='md' />
                    </Box>}
                <ModalSendCopy flowId={item?.id} showModal={showModal} setShowModal={setShowModal} />
                <ModalReport taskId={market ? item?.workflowid : item?.flowData ? item?.id : item?.workflowId} studioTask={!!item?.flowData} showModal={showReport} setShowModal={setShowReport} />
            </VStack >
        </CardFrame>
    );
}
